var map = {
	"./booking/auction.svg": [
		"./src/assets/images/booking/auction.svg",
		54474
	],
	"./booking/booking_advanced_search.svg": [
		"./src/assets/images/booking/booking_advanced_search.svg",
		41012
	],
	"./booking/booking_create_resource.svg": [
		"./src/assets/images/booking/booking_create_resource.svg",
		54822
	],
	"./booking/booking_create_shifts.svg": [
		"./src/assets/images/booking/booking_create_shifts.svg",
		43497
	],
	"./booking/booking_export_shifts.svg": [
		"./src/assets/images/booking/booking_export_shifts.svg",
		79871
	],
	"./booking/booking_import_shifts.svg": [
		"./src/assets/images/booking/booking_import_shifts.svg",
		48548
	],
	"./booking/booking_optimization.svg": [
		"./src/assets/images/booking/booking_optimization.svg",
		30504
	],
	"./booking/booking_print.svg": [
		"./src/assets/images/booking/booking_print.svg",
		83700
	],
	"./booking/booking_route_optimization.svg": [
		"./src/assets/images/booking/booking_route_optimization.svg",
		5658
	],
	"./booking/booking_service_plan.svg": [
		"./src/assets/images/booking/booking_service_plan.svg",
		63966
	],
	"./booking/booking_statistics.svg": [
		"./src/assets/images/booking/booking_statistics.svg",
		84386
	],
	"./booking/booking_taskTable.svg": [
		"./src/assets/images/booking/booking_taskTable.svg",
		84764
	],
	"./booking/booking_task_administration.svg": [
		"./src/assets/images/booking/booking_task_administration.svg",
		21405
	],
	"./booking/booking_vehicle_bike_not_selected.svg": [
		"./src/assets/images/booking/booking_vehicle_bike_not_selected.svg",
		74499
	],
	"./booking/booking_vehicle_bike_selected.svg": [
		"./src/assets/images/booking/booking_vehicle_bike_selected.svg",
		81129
	],
	"./booking/booking_vehicle_bus_not_selected.svg": [
		"./src/assets/images/booking/booking_vehicle_bus_not_selected.svg",
		54396
	],
	"./booking/booking_vehicle_bus_selected.svg": [
		"./src/assets/images/booking/booking_vehicle_bus_selected.svg",
		10122
	],
	"./booking/booking_vehicle_car_not_selected.svg": [
		"./src/assets/images/booking/booking_vehicle_car_not_selected.svg",
		49076
	],
	"./booking/booking_vehicle_car_selected.svg": [
		"./src/assets/images/booking/booking_vehicle_car_selected.svg",
		96722
	],
	"./booking/map_skeleton.png": [
		"./src/assets/images/booking/map_skeleton.png",
		6515
	],
	"./brand/DomaCare_color_RGB_black_text.svg": [
		"./src/assets/images/brand/DomaCare_color_RGB_black_text.svg"
	],
	"./brand/DomaCare_color_RGB_white_text.svg": [
		"./src/assets/images/brand/DomaCare_color_RGB_white_text.svg"
	],
	"./brand/domacare_favicon_144x144.png": [
		"./src/assets/images/brand/domacare_favicon_144x144.png",
		87875
	],
	"./brand/domacare_favicon_192x192.png": [
		"./src/assets/images/brand/domacare_favicon_192x192.png",
		81419
	],
	"./brand/domacare_favicon_48x48.png": [
		"./src/assets/images/brand/domacare_favicon_48x48.png",
		67531
	],
	"./brand/domacare_favicon_96x96.png": [
		"./src/assets/images/brand/domacare_favicon_96x96.png",
		79153
	],
	"./brand/domacare_icon.svg": [
		"./src/assets/images/brand/domacare_icon.svg",
		75073
	],
	"./brand/domacare_pelkka-logo.svg": [
		"./src/assets/images/brand/domacare_pelkka-logo.svg",
		83784
	],
	"./card/domasigner_nocard.png": [
		"./src/assets/images/card/domasigner_nocard.png",
		45061
	],
	"./card/removecard.png": [
		"./src/assets/images/card/removecard.png",
		62648
	],
	"./careplan/CAREPLAN_HEIKKO_TUKIJARJESTELMA.svg": [
		"./src/assets/images/careplan/CAREPLAN_HEIKKO_TUKIJARJESTELMA.svg",
		44036
	],
	"./careplan/CAREPLAN_HOITOON_SITOUTUMINEN.svg": [
		"./src/assets/images/careplan/CAREPLAN_HOITOON_SITOUTUMINEN.svg",
		19580
	],
	"./careplan/CAREPLAN_KOULUTUS_JA_TYOLLISYYS.svg": [
		"./src/assets/images/careplan/CAREPLAN_KOULUTUS_JA_TYOLLISYYS.svg",
		24829
	],
	"./careplan/CAREPLAN_LAITOSHOITOON_JOUTUMISEN_UHKA.svg": [
		"./src/assets/images/careplan/CAREPLAN_LAITOSHOITOON_JOUTUMISEN_UHKA.svg",
		49557
	],
	"./careplan/CAREPLAN_MOOD.svg": [
		"./src/assets/images/careplan/CAREPLAN_MOOD.svg",
		92832
	],
	"./careplan/CAREPLAN_PAIVITTAISET_TOIMINNOT.svg": [
		"./src/assets/images/careplan/CAREPLAN_PAIVITTAISET_TOIMINNOT.svg",
		85926
	],
	"./careplan/CAREPLAN_TERVEYDENTILA.svg": [
		"./src/assets/images/careplan/CAREPLAN_TERVEYDENTILA.svg",
		82047
	],
	"./careplan/info.svg": [
		"./src/assets/images/careplan/info.svg",
		32688
	],
	"./careplan/symbol_rai_aktiviteetti.svg": [
		"./src/assets/images/careplan/symbol_rai_aktiviteetti.svg",
		11797
	],
	"./careplan/symbol_rai_kaytosoireet.svg": [
		"./src/assets/images/careplan/symbol_rai_kaytosoireet.svg",
		4057
	],
	"./careplan/symbol_rai_ravitsemus.svg": [
		"./src/assets/images/careplan/symbol_rai_ravitsemus.svg",
		94453
	],
	"./careplan/symbol_rai_selviytyminen.svg": [
		"./src/assets/images/careplan/symbol_rai_selviytyminen.svg",
		50346
	],
	"./customer/absent.svg": [
		"./src/assets/images/customer/absent.svg",
		35909
	],
	"./customer/asiakkaan-kuva_harmaa.svg": [
		"./src/assets/images/customer/asiakkaan-kuva_harmaa.svg",
		41327
	],
	"./customer/assignation_log.svg": [
		"./src/assets/images/customer/assignation_log.svg",
		31
	],
	"./customer/call.svg": [
		"./src/assets/images/customer/call.svg",
		72846
	],
	"./customer/careplan.svg": [
		"./src/assets/images/customer/careplan.svg",
		1704
	],
	"./customer/cash_register.svg": [
		"./src/assets/images/customer/cash_register.svg",
		66001
	],
	"./customer/cpmenu_preferred_employee.svg": [
		"./src/assets/images/customer/cpmenu_preferred_employee.svg",
		48647
	],
	"./customer/cpmenu_submenu1.svg": [
		"./src/assets/images/customer/cpmenu_submenu1.svg",
		16317
	],
	"./customer/cpmenu_submenu2.svg": [
		"./src/assets/images/customer/cpmenu_submenu2.svg",
		62142
	],
	"./customer/customer_files.svg": [
		"./src/assets/images/customer/customer_files.svg",
		60638
	],
	"./customer/daily_reports.svg": [
		"./src/assets/images/customer/daily_reports.svg",
		93157
	],
	"./customer/diagnoses.svg": [
		"./src/assets/images/customer/diagnoses.svg",
		29077
	],
	"./customer/document.svg": [
		"./src/assets/images/customer/document.svg",
		75953
	],
	"./customer/documents.svg": [
		"./src/assets/images/customer/documents.svg",
		73088
	],
	"./customer/edit-hover.svg": [
		"./src/assets/images/customer/edit-hover.svg",
		59103
	],
	"./customer/edit.svg": [
		"./src/assets/images/customer/edit.svg",
		11534
	],
	"./customer/events.svg": [
		"./src/assets/images/customer/events.svg",
		56937
	],
	"./customer/files.svg": [
		"./src/assets/images/customer/files.svg",
		95387
	],
	"./customer/images.svg": [
		"./src/assets/images/customer/images.svg",
		31888
	],
	"./customer/key_log.svg": [
		"./src/assets/images/customer/key_log.svg",
		91412
	],
	"./customer/keys.svg": [
		"./src/assets/images/customer/keys.svg",
		33198
	],
	"./customer/medication.svg": [
		"./src/assets/images/customer/medication.svg",
		33647
	],
	"./customer/nuoli-aukaise-valikko_valkoinen.svg": [
		"./src/assets/images/customer/nuoli-aukaise-valikko_valkoinen.svg",
		94691
	],
	"./customer/nuoli-oikea_harmaa.svg": [
		"./src/assets/images/customer/nuoli-oikea_harmaa.svg",
		30158
	],
	"./customer/nuoli-oikea_harmaa_disabled.svg": [
		"./src/assets/images/customer/nuoli-oikea_harmaa_disabled.svg",
		98837
	],
	"./customer/nuoli-oikea_valkoinen.svg": [
		"./src/assets/images/customer/nuoli-oikea_valkoinen.svg",
		29981
	],
	"./customer/nuoli-valikon-aukaisu_valkoinen.svg": [
		"./src/assets/images/customer/nuoli-valikon-aukaisu_valkoinen.svg",
		90326
	],
	"./customer/nuoli-vasen_harmaa.svg": [
		"./src/assets/images/customer/nuoli-vasen_harmaa.svg",
		51036
	],
	"./customer/nuoli-vasen_harmaa_disabled.svg": [
		"./src/assets/images/customer/nuoli-vasen_harmaa_disabled.svg",
		10003
	],
	"./customer/nuoli-vasen_valkoinen.svg": [
		"./src/assets/images/customer/nuoli-vasen_valkoinen.svg",
		42439
	],
	"./customer/nuoli-ympyrassa-umpinainen_harmaa.svg": [
		"./src/assets/images/customer/nuoli-ympyrassa-umpinainen_harmaa.svg",
		60569
	],
	"./customer/nuoli-ympyrassa_harmaa.svg": [
		"./src/assets/images/customer/nuoli-ympyrassa_harmaa.svg",
		27880
	],
	"./customer/nuoli-ympyrassa_valkoinen.svg": [
		"./src/assets/images/customer/nuoli-ympyrassa_valkoinen.svg",
		51619
	],
	"./customer/personal.svg": [
		"./src/assets/images/customer/personal.svg",
		91978
	],
	"./customer/physio.svg": [
		"./src/assets/images/customer/physio.svg",
		27486
	],
	"./customer/present.svg": [
		"./src/assets/images/customer/present.svg",
		16827
	],
	"./customer/priority_orange.svg": [
		"./src/assets/images/customer/priority_orange.svg",
		26455
	],
	"./customer/priority_red.svg": [
		"./src/assets/images/customer/priority_red.svg",
		37114
	],
	"./customer/rai.svg": [
		"./src/assets/images/customer/rai.svg",
		7790
	],
	"./customer/report.svg": [
		"./src/assets/images/customer/report.svg",
		93980
	],
	"./customer/star_grey.svg": [
		"./src/assets/images/customer/star_grey.svg",
		55084
	],
	"./customer/star_yellow.svg": [
		"./src/assets/images/customer/star_yellow.svg",
		93557
	],
	"./customer/symbol_info.svg": [
		"./src/assets/images/customer/symbol_info.svg",
		43469
	],
	"./customer/symbol_psykososiaalinen-hyvinvointi-kohentaminen.svg": [
		"./src/assets/images/customer/symbol_psykososiaalinen-hyvinvointi-kohentaminen.svg",
		64565
	],
	"./customer/symbol_psykososiaalinen-hyvinvointi-ongelmat.svg": [
		"./src/assets/images/customer/symbol_psykososiaalinen-hyvinvointi-ongelmat.svg",
		33655
	],
	"./customer/symbol_psykososiaalinen_hyvinvointi_kohentaminen.svg": [
		"./src/assets/images/customer/symbol_psykososiaalinen_hyvinvointi_kohentaminen.svg",
		99885
	],
	"./customer/symbol_psykososiaalinen_hyvinvointi_ongelmat.svg": [
		"./src/assets/images/customer/symbol_psykososiaalinen_hyvinvointi_ongelmat.svg",
		99599
	],
	"./customer/symbol_psyykenlaakitys-kaytosoireet.svg": [
		"./src/assets/images/customer/symbol_psyykenlaakitys-kaytosoireet.svg",
		88820
	],
	"./customer/symbol_psyykenlaakitys-muu.svg": [
		"./src/assets/images/customer/symbol_psyykenlaakitys-muu.svg",
		78432
	],
	"./customer/symbol_psyykenlaakitys-verenpaine.svg": [
		"./src/assets/images/customer/symbol_psyykenlaakitys-verenpaine.svg",
		8870
	],
	"./customer/symbol_psyykenlaakitys_kaytosoireet.svg": [
		"./src/assets/images/customer/symbol_psyykenlaakitys_kaytosoireet.svg",
		82866
	],
	"./customer/symbol_psyykenlaakitys_muu.svg": [
		"./src/assets/images/customer/symbol_psyykenlaakitys_muu.svg",
		46254
	],
	"./customer/symbol_psyykenlaakitys_verenpaine.svg": [
		"./src/assets/images/customer/symbol_psyykenlaakitys_verenpaine.svg",
		64368
	],
	"./customer/tasks.svg": [
		"./src/assets/images/customer/tasks.svg",
		2496
	],
	"./customer/wallet.svg": [
		"./src/assets/images/customer/wallet.svg",
		8701
	],
	"./duties/icon_duties.svg": [
		"./src/assets/images/duties/icon_duties.svg",
		30144
	],
	"./duties/icon_duties_2.svg": [
		"./src/assets/images/duties/icon_duties_2.svg"
	],
	"./error-pages/error-access-denied.svg": [
		"./src/assets/images/error-pages/error-access-denied.svg",
		5086
	],
	"./error-pages/page_not_found.svg": [
		"./src/assets/images/error-pages/page_not_found.svg",
		18977
	],
	"./error-pages/server_down.svg": [
		"./src/assets/images/error-pages/server_down.svg"
	],
	"./error-pages/server_error.svg": [
		"./src/assets/images/error-pages/server_error.svg"
	],
	"./error-pages/server_maintenance.svg": [
		"./src/assets/images/error-pages/server_maintenance.svg",
		11770
	],
	"./errorBoundary/crash.svg": [
		"./src/assets/images/errorBoundary/crash.svg",
		90897
	],
	"./favicon.ico": [
		"./src/assets/images/favicon.ico",
		30804
	],
	"./goalsSymbols/RAI-hoitosuunnitelma (1).zip": [
		"./src/assets/images/goalsSymbols/RAI-hoitosuunnitelma (1).zip",
		58113
	],
	"./goalsSymbols/heikko_tukijarjestelma_new.svg": [
		"./src/assets/images/goalsSymbols/heikko_tukijarjestelma_new.svg",
		33809
	],
	"./goalsSymbols/hoitoon_sitoutuminen_new.svg": [
		"./src/assets/images/goalsSymbols/hoitoon_sitoutuminen_new.svg",
		34017
	],
	"./goalsSymbols/koulutus_ja_tyollisyys_new.svg": [
		"./src/assets/images/goalsSymbols/koulutus_ja_tyollisyys_new.svg",
		34692
	],
	"./goalsSymbols/laitoshoitoon_joutumisen_uhka_new.svg": [
		"./src/assets/images/goalsSymbols/laitoshoitoon_joutumisen_uhka_new.svg",
		16720
	],
	"./goalsSymbols/rai_aktiviteetti.svg": [
		"./src/assets/images/goalsSymbols/rai_aktiviteetti.svg",
		39837
	],
	"./goalsSymbols/rai_kaytosoireet.svg": [
		"./src/assets/images/goalsSymbols/rai_kaytosoireet.svg",
		39185
	],
	"./goalsSymbols/rai_mieliala.svg": [
		"./src/assets/images/goalsSymbols/rai_mieliala.svg",
		9690
	],
	"./goalsSymbols/rai_paivittaiset_toiminnot.svg": [
		"./src/assets/images/goalsSymbols/rai_paivittaiset_toiminnot.svg",
		19307
	],
	"./goalsSymbols/rai_ravitsemus.svg": [
		"./src/assets/images/goalsSymbols/rai_ravitsemus.svg",
		46621
	],
	"./goalsSymbols/rai_selviytyminen.svg": [
		"./src/assets/images/goalsSymbols/rai_selviytyminen.svg",
		20066
	],
	"./goalsSymbols/rai_terveydentila.svg": [
		"./src/assets/images/goalsSymbols/rai_terveydentila.svg",
		71644
	],
	"./login/mainpage_bg-min.jpg": [
		"./src/assets/images/login/mainpage_bg-min.jpg",
		6602
	],
	"./newSVG/ic_done_white.svg": [
		"./src/assets/images/newSVG/ic_done_white.svg",
		67399
	],
	"./newSVG/icon_close.svg": [
		"./src/assets/images/newSVG/icon_close.svg",
		95084
	],
	"./newSVG/icon_settings--hover.svg": [
		"./src/assets/images/newSVG/icon_settings--hover.svg",
		46397
	],
	"./newSVG/icon_submenu_1.svg": [
		"./src/assets/images/newSVG/icon_submenu_1.svg",
		9919
	],
	"./newSVG/icon_submenu_2.svg": [
		"./src/assets/images/newSVG/icon_submenu_2.svg",
		47244
	],
	"./sharedComponent/clock.svg": [
		"./src/assets/images/sharedComponent/clock.svg",
		41354
	],
	"./sideNav/icon-rai-stats-hover.svg": [
		"./src/assets/images/sideNav/icon-rai-stats-hover.svg",
		11411
	],
	"./sideNav/icon-rai-stats.svg": [
		"./src/assets/images/sideNav/icon-rai-stats.svg",
		5778
	],
	"./sideNav/icon_auction--hover.svg": [
		"./src/assets/images/sideNav/icon_auction--hover.svg",
		79527
	],
	"./sideNav/icon_auction.svg": [
		"./src/assets/images/sideNav/icon_auction.svg",
		7201
	],
	"./sideNav/icon_calendar--hover.svg": [
		"./src/assets/images/sideNav/icon_calendar--hover.svg",
		39160
	],
	"./sideNav/icon_calendar.svg": [
		"./src/assets/images/sideNav/icon_calendar.svg",
		99464
	],
	"./sideNav/icon_customers--hover.svg": [
		"./src/assets/images/sideNav/icon_customers--hover.svg",
		83115
	],
	"./sideNav/icon_customers.svg": [
		"./src/assets/images/sideNav/icon_customers.svg",
		88661
	],
	"./sideNav/icon_duties--hover.svg": [
		"./src/assets/images/sideNav/icon_duties--hover.svg",
		79766
	],
	"./sideNav/icon_duties.svg": [
		"./src/assets/images/sideNav/icon_duties.svg",
		91014
	],
	"./sideNav/icon_duties_2.svg": [
		"./src/assets/images/sideNav/icon_duties_2.svg",
		49493
	],
	"./sideNav/icon_logout--hover.svg": [
		"./src/assets/images/sideNav/icon_logout--hover.svg",
		87568
	],
	"./sideNav/icon_logout.svg": [
		"./src/assets/images/sideNav/icon_logout.svg",
		92720
	],
	"./sideNav/icon_menu-white.svg": [
		"./src/assets/images/sideNav/icon_menu-white.svg",
		41203
	],
	"./sideNav/icon_menu.svg": [
		"./src/assets/images/sideNav/icon_menu.svg",
		18643
	],
	"./sideNav/icon_messages--hover.svg": [
		"./src/assets/images/sideNav/icon_messages--hover.svg",
		87134
	],
	"./sideNav/icon_messages.svg": [
		"./src/assets/images/sideNav/icon_messages.svg",
		24030
	],
	"./sideNav/icon_settings--hover.svg": [
		"./src/assets/images/sideNav/icon_settings--hover.svg",
		26807
	],
	"./sideNav/icon_settings.svg": [
		"./src/assets/images/sideNav/icon_settings.svg",
		52433
	],
	"./sideNav/icon_tasks--hover.svg": [
		"./src/assets/images/sideNav/icon_tasks--hover.svg",
		63720
	],
	"./sideNav/icon_tasks.svg": [
		"./src/assets/images/sideNav/icon_tasks.svg",
		61528
	],
	"./sideNav/icon_user--hover.svg": [
		"./src/assets/images/sideNav/icon_user--hover.svg",
		71889
	],
	"./sideNav/icon_user.svg": [
		"./src/assets/images/sideNav/icon_user.svg",
		39379
	],
	"./sideNav/icon_wallet--hover.svg": [
		"./src/assets/images/sideNav/icon_wallet--hover.svg",
		2891
	],
	"./sideNav/icon_wallet.svg": [
		"./src/assets/images/sideNav/icon_wallet.svg",
		26005
	],
	"./sideNav/menu.svg": [
		"./src/assets/images/sideNav/menu.svg",
		24897
	],
	"./symbols/absent.svg": [
		"./src/assets/images/symbols/absent.svg",
		84338
	],
	"./symbols/activities.svg": [
		"./src/assets/images/symbols/activities.svg",
		16002
	],
	"./symbols/adl-toiminnot-kuntoutus.svg": [
		"./src/assets/images/symbols/adl-toiminnot-kuntoutus.svg",
		49875
	],
	"./symbols/adl_toiminnot_kuntoutus.svg": [
		"./src/assets/images/symbols/adl_toiminnot_kuntoutus.svg",
		41139
	],
	"./symbols/aids.svg": [
		"./src/assets/images/symbols/aids.svg",
		59916
	],
	"./symbols/aistit_ja_neurologiset_toiminnot.svg": [
		"./src/assets/images/symbols/aistit_ja_neurologiset_toiminnot.svg",
		79810
	],
	"./symbols/aktiviteetit_muutos.svg": [
		"./src/assets/images/symbols/aktiviteetit_muutos.svg",
		90234
	],
	"./symbols/aktiviteetit_tarkistus.svg": [
		"./src/assets/images/symbols/aktiviteetit_tarkistus.svg",
		32759
	],
	"./symbols/akuutti_sekavuus.svg": [
		"./src/assets/images/symbols/akuutti_sekavuus.svg",
		2816
	],
	"./symbols/alertness.svg": [
		"./src/assets/images/symbols/alertness.svg",
		9492
	],
	"./symbols/angry.svg": [
		"./src/assets/images/symbols/angry.svg",
		26448
	],
	"./symbols/asiakkaan-kuva_harmaa.svg": [
		"./src/assets/images/symbols/asiakkaan-kuva_harmaa.svg",
		14906
	],
	"./symbols/assessments.svg": [
		"./src/assets/images/symbols/assessments.svg",
		77870
	],
	"./symbols/assignation_log.svg": [
		"./src/assets/images/symbols/assignation_log.svg",
		60534
	],
	"./symbols/basic.svg": [
		"./src/assets/images/symbols/basic.svg",
		95109
	],
	"./symbols/basic_vital_signs.svg": [
		"./src/assets/images/symbols/basic_vital_signs.svg",
		68249
	],
	"./symbols/be_aware_of_own_conditions.svg": [
		"./src/assets/images/symbols/be_aware_of_own_conditions.svg",
		74311
	],
	"./symbols/call.svg": [
		"./src/assets/images/symbols/call.svg",
		20509
	],
	"./symbols/careplan.svg": [
		"./src/assets/images/symbols/careplan.svg",
		84679
	],
	"./symbols/cash_register.svg": [
		"./src/assets/images/symbols/cash_register.svg",
		33788
	],
	"./symbols/circadian_rhythm_maintenance.svg": [
		"./src/assets/images/symbols/circadian_rhythm_maintenance.svg",
		89304
	],
	"./symbols/communication.svg": [
		"./src/assets/images/symbols/communication.svg",
		40043
	],
	"./symbols/cpmenu_submenu1.svg": [
		"./src/assets/images/symbols/cpmenu_submenu1.svg",
		7368
	],
	"./symbols/cpmenu_submenu2.svg": [
		"./src/assets/images/symbols/cpmenu_submenu2.svg",
		58107
	],
	"./symbols/crash.svg": [
		"./src/assets/images/symbols/crash.svg",
		38254
	],
	"./symbols/crying.svg": [
		"./src/assets/images/symbols/crying.svg",
		84061
	],
	"./symbols/customer_files.svg": [
		"./src/assets/images/symbols/customer_files.svg",
		83593
	],
	"./symbols/customer_visit.svg": [
		"./src/assets/images/symbols/customer_visit.svg",
		19501
	],
	"./symbols/daily_reports.svg": [
		"./src/assets/images/symbols/daily_reports.svg",
		29988
	],
	"./symbols/daily_routines.svg": [
		"./src/assets/images/symbols/daily_routines.svg",
		78500
	],
	"./symbols/dark_cloud.svg": [
		"./src/assets/images/symbols/dark_cloud.svg",
		61859
	],
	"./symbols/dark_cloud_grey.svg": [
		"./src/assets/images/symbols/dark_cloud_grey.svg",
		27767
	],
	"./symbols/diagnoses.svg": [
		"./src/assets/images/symbols/diagnoses.svg",
		1732
	],
	"./symbols/disturbing.svg": [
		"./src/assets/images/symbols/disturbing.svg",
		10570
	],
	"./symbols/doctor.svg": [
		"./src/assets/images/symbols/doctor.svg",
		89564
	],
	"./symbols/document.svg": [
		"./src/assets/images/symbols/document.svg",
		25382
	],
	"./symbols/documents.svg": [
		"./src/assets/images/symbols/documents.svg",
		56089
	],
	"./symbols/dressing.svg": [
		"./src/assets/images/symbols/dressing.svg",
		53898
	],
	"./symbols/drug_and_alcohol_misuse.svg": [
		"./src/assets/images/symbols/drug_and_alcohol_misuse.svg",
		45519
	],
	"./symbols/e_services.svg": [
		"./src/assets/images/symbols/e_services.svg",
		10845
	],
	"./symbols/edit-hover.svg": [
		"./src/assets/images/symbols/edit-hover.svg",
		89900
	],
	"./symbols/edit.svg": [
		"./src/assets/images/symbols/edit.svg",
		16913
	],
	"./symbols/elamankaari.svg": [
		"./src/assets/images/symbols/elamankaari.svg",
		90137
	],
	"./symbols/ennaltaehkaisevat_toimet.svg": [
		"./src/assets/images/symbols/ennaltaehkaisevat_toimet.svg",
		32302
	],
	"./symbols/epamuodollinen_tuki.svg": [
		"./src/assets/images/symbols/epamuodollinen_tuki.svg",
		58319
	],
	"./symbols/events.svg": [
		"./src/assets/images/symbols/events.svg",
		28486
	],
	"./symbols/exclamation.svg": [
		"./src/assets/images/symbols/exclamation.svg",
		88128
	],
	"./symbols/files.svg": [
		"./src/assets/images/symbols/files.svg",
		46402
	],
	"./symbols/first_aid.svg": [
		"./src/assets/images/symbols/first_aid.svg",
		42038
	],
	"./symbols/hairioton_asuminen.svg": [
		"./src/assets/images/symbols/hairioton_asuminen.svg",
		10129
	],
	"./symbols/health_care_use.svg": [
		"./src/assets/images/symbols/health_care_use.svg",
		24117
	],
	"./symbols/heikko_tukijarjestelma.svg": [
		"./src/assets/images/symbols/heikko_tukijarjestelma.svg",
		1116
	],
	"./symbols/hoitoon_sitoutuminen.svg": [
		"./src/assets/images/symbols/hoitoon_sitoutuminen.svg",
		47556
	],
	"./symbols/hospice.svg": [
		"./src/assets/images/symbols/hospice.svg",
		92304
	],
	"./symbols/housekeepiing.svg": [
		"./src/assets/images/symbols/housekeepiing.svg",
		35859
	],
	"./symbols/hygiene.svg": [
		"./src/assets/images/symbols/hygiene.svg",
		68318
	],
	"./symbols/illness_attack.svg": [
		"./src/assets/images/symbols/illness_attack.svg",
		41018
	],
	"./symbols/images.svg": [
		"./src/assets/images/symbols/images.svg",
		68143
	],
	"./symbols/info.svg": [
		"./src/assets/images/symbols/info.svg",
		75465
	],
	"./symbols/injury.svg": [
		"./src/assets/images/symbols/injury.svg",
		94556
	],
	"./symbols/kantaphase_evaluation.svg": [
		"./src/assets/images/symbols/kantaphase_evaluation.svg",
		994
	],
	"./symbols/kantaphase_execution.svg": [
		"./src/assets/images/symbols/kantaphase_execution.svg",
		11094
	],
	"./symbols/kantaphase_none.svg": [
		"./src/assets/images/symbols/kantaphase_none.svg",
		88490
	],
	"./symbols/kantaphase_planning.svg": [
		"./src/assets/images/symbols/kantaphase_planning.svg",
		73871
	],
	"./symbols/kantaphase_preparation.svg": [
		"./src/assets/images/symbols/kantaphase_preparation.svg",
		89887
	],
	"./symbols/kaytosoireet.svg": [
		"./src/assets/images/symbols/kaytosoireet.svg",
		57240
	],
	"./symbols/key_log.svg": [
		"./src/assets/images/symbols/key_log.svg",
		48425
	],
	"./symbols/keys.svg": [
		"./src/assets/images/symbols/keys.svg",
		5277
	],
	"./symbols/kipu.svg": [
		"./src/assets/images/symbols/kipu.svg",
		97736
	],
	"./symbols/kognitiivinen_kyky.svg": [
		"./src/assets/images/symbols/kognitiivinen_kyky.svg",
		71704
	],
	"./symbols/kognitiivisen-kyvyn-vaje.svg": [
		"./src/assets/images/symbols/kognitiivisen-kyvyn-vaje.svg",
		9773
	],
	"./symbols/kognitiivisen_kyvyn_vaje.svg": [
		"./src/assets/images/symbols/kognitiivisen_kyvyn_vaje.svg",
		17353
	],
	"./symbols/kommunikaatio_vaikeudet.svg": [
		"./src/assets/images/symbols/kommunikaatio_vaikeudet.svg",
		74775
	],
	"./symbols/koulutus_ja_tyollisyys.svg": [
		"./src/assets/images/symbols/koulutus_ja_tyollisyys.svg",
		63941
	],
	"./symbols/kuivuminen.svg": [
		"./src/assets/images/symbols/kuivuminen.svg",
		37322
	],
	"./symbols/kuntoilu.svg": [
		"./src/assets/images/symbols/kuntoilu.svg",
		68506
	],
	"./symbols/laitoshoitoon_joutumisen_uhka.svg": [
		"./src/assets/images/symbols/laitoshoitoon_joutumisen_uhka.svg",
		68125
	],
	"./symbols/letkuravitsemus.svg": [
		"./src/assets/images/symbols/letkuravitsemus.svg",
		97241
	],
	"./symbols/light_cloud.svg": [
		"./src/assets/images/symbols/light_cloud.svg",
		22677
	],
	"./symbols/light_cloud_grey.svg": [
		"./src/assets/images/symbols/light_cloud_grey.svg",
		67553
	],
	"./symbols/living_skills.svg": [
		"./src/assets/images/symbols/living_skills.svg",
		72419
	],
	"./symbols/masennus_ja_ahdistuneisuus.svg": [
		"./src/assets/images/symbols/masennus_ja_ahdistuneisuus.svg",
		87544
	],
	"./symbols/measurements.svg": [
		"./src/assets/images/symbols/measurements.svg",
		86318
	],
	"./symbols/medication.svg": [
		"./src/assets/images/symbols/medication.svg",
		23600
	],
	"./symbols/mobility.svg": [
		"./src/assets/images/symbols/mobility.svg",
		42346
	],
	"./symbols/mood-1.svg": [
		"./src/assets/images/symbols/mood-1.svg",
		40486
	],
	"./symbols/mood-1_grey.svg": [
		"./src/assets/images/symbols/mood-1_grey.svg",
		41672
	],
	"./symbols/mood-2.svg": [
		"./src/assets/images/symbols/mood-2.svg",
		62917
	],
	"./symbols/mood-2_grey.svg": [
		"./src/assets/images/symbols/mood-2_grey.svg",
		17521
	],
	"./symbols/mood-3.svg": [
		"./src/assets/images/symbols/mood-3.svg",
		11748
	],
	"./symbols/mood-3_grey.svg": [
		"./src/assets/images/symbols/mood-3_grey.svg",
		5006
	],
	"./symbols/mood-4.svg": [
		"./src/assets/images/symbols/mood-4.svg",
		16427
	],
	"./symbols/mood-4_grey.svg": [
		"./src/assets/images/symbols/mood-4_grey.svg",
		27599
	],
	"./symbols/mood-5.svg": [
		"./src/assets/images/symbols/mood-5.svg",
		1818
	],
	"./symbols/mood-5_grey.svg": [
		"./src/assets/images/symbols/mood-5_grey.svg",
		91628
	],
	"./symbols/mood-6.svg": [
		"./src/assets/images/symbols/mood-6.svg",
		69929
	],
	"./symbols/mood-6_grey.svg": [
		"./src/assets/images/symbols/mood-6_grey.svg",
		36597
	],
	"./symbols/mood-7.svg": [
		"./src/assets/images/symbols/mood-7.svg",
		65688
	],
	"./symbols/mood-7_grey.svg": [
		"./src/assets/images/symbols/mood-7_grey.svg",
		20002
	],
	"./symbols/mood.svg": [
		"./src/assets/images/symbols/mood.svg",
		16136
	],
	"./symbols/nako.svg": [
		"./src/assets/images/symbols/nako.svg",
		24808
	],
	"./symbols/nakokyky.svg": [
		"./src/assets/images/symbols/nakokyky.svg",
		55864
	],
	"./symbols/nestetasapaino.svg": [
		"./src/assets/images/symbols/nestetasapaino.svg",
		65396
	],
	"./symbols/no_symbol.svg": [
		"./src/assets/images/symbols/no_symbol.svg",
		55247
	],
	"./symbols/nothing.svg": [
		"./src/assets/images/symbols/nothing.svg",
		5376
	],
	"./symbols/notice.svg": [
		"./src/assets/images/symbols/notice.svg",
		19429
	],
	"./symbols/nuoli-aukaise-valikko_valkoinen.svg": [
		"./src/assets/images/symbols/nuoli-aukaise-valikko_valkoinen.svg",
		41858
	],
	"./symbols/nuoli-oikea_harmaa.svg": [
		"./src/assets/images/symbols/nuoli-oikea_harmaa.svg",
		43941
	],
	"./symbols/nuoli-oikea_valkoinen.svg": [
		"./src/assets/images/symbols/nuoli-oikea_valkoinen.svg",
		51848
	],
	"./symbols/nuoli-valikon-aukaisu_valkoinen.svg": [
		"./src/assets/images/symbols/nuoli-valikon-aukaisu_valkoinen.svg",
		10487
	],
	"./symbols/nuoli-vasen_harmaa.svg": [
		"./src/assets/images/symbols/nuoli-vasen_harmaa.svg",
		1219
	],
	"./symbols/nuoli-vasen_valkoinen.svg": [
		"./src/assets/images/symbols/nuoli-vasen_valkoinen.svg",
		75346
	],
	"./symbols/nuoli-ympyrassa-umpinainen_harmaa.svg": [
		"./src/assets/images/symbols/nuoli-ympyrassa-umpinainen_harmaa.svg",
		46980
	],
	"./symbols/nuoli-ympyrassa_harmaa.svg": [
		"./src/assets/images/symbols/nuoli-ympyrassa_harmaa.svg",
		34603
	],
	"./symbols/nuoli-ympyrassa_valkoinen.svg": [
		"./src/assets/images/symbols/nuoli-ympyrassa_valkoinen.svg",
		746
	],
	"./symbols/nutrition.svg": [
		"./src/assets/images/symbols/nutrition.svg",
		79231
	],
	"./symbols/ol.svg": [
		"./src/assets/images/symbols/ol.svg",
		82004
	],
	"./symbols/open_symbol_menu.svg": [
		"./src/assets/images/symbols/open_symbol_menu.svg",
		846
	],
	"./symbols/painehaavan_uhka.svg": [
		"./src/assets/images/symbols/painehaavan_uhka.svg",
		12301
	],
	"./symbols/painonhallinta.svg": [
		"./src/assets/images/symbols/painonhallinta.svg",
		4739
	],
	"./symbols/partially_cloudy.svg": [
		"./src/assets/images/symbols/partially_cloudy.svg",
		64092
	],
	"./symbols/partially_cloudy_grey.svg": [
		"./src/assets/images/symbols/partially_cloudy_grey.svg",
		32694
	],
	"./symbols/passive.svg": [
		"./src/assets/images/symbols/passive.svg",
		40480
	],
	"./symbols/personal.svg": [
		"./src/assets/images/symbols/personal.svg",
		54941
	],
	"./symbols/personal_economy.svg": [
		"./src/assets/images/symbols/personal_economy.svg",
		13944
	],
	"./symbols/physio.svg": [
		"./src/assets/images/symbols/physio.svg",
		59585
	],
	"./symbols/present.svg": [
		"./src/assets/images/symbols/present.svg",
		18546
	],
	"./symbols/priority_orange.svg": [
		"./src/assets/images/symbols/priority_orange.svg",
		52846
	],
	"./symbols/priority_red.svg": [
		"./src/assets/images/symbols/priority_red.svg",
		66173
	],
	"./symbols/psykososiaalinen_hyvinvointi_kohentaminen.svg": [
		"./src/assets/images/symbols/psykososiaalinen_hyvinvointi_kohentaminen.svg",
		89209
	],
	"./symbols/psykososiaalinen_hyvinvointi_ongelmat.svg": [
		"./src/assets/images/symbols/psykososiaalinen_hyvinvointi_ongelmat.svg",
		53683
	],
	"./symbols/psyykenlaakitys-kaytosoireet.svg": [
		"./src/assets/images/symbols/psyykenlaakitys-kaytosoireet.svg",
		22976
	],
	"./symbols/psyykenlaakitys-muu.svg": [
		"./src/assets/images/symbols/psyykenlaakitys-muu.svg",
		40860
	],
	"./symbols/psyykenlaakitys-verenpaine.svg": [
		"./src/assets/images/symbols/psyykenlaakitys-verenpaine.svg",
		2818
	],
	"./symbols/psyykenlaakitys_kaytosoireet.svg": [
		"./src/assets/images/symbols/psyykenlaakitys_kaytosoireet.svg",
		47614
	],
	"./symbols/psyykenlaakitys_muu.svg": [
		"./src/assets/images/symbols/psyykenlaakitys_muu.svg",
		56842
	],
	"./symbols/psyykenlaakitys_verenpaine.svg": [
		"./src/assets/images/symbols/psyykenlaakitys_verenpaine.svg",
		43596
	],
	"./symbols/psyykenlaakkeet.svg": [
		"./src/assets/images/symbols/psyykenlaakkeet.svg",
		20732
	],
	"./symbols/psyykkinen_tasapaino.svg": [
		"./src/assets/images/symbols/psyykkinen_tasapaino.svg",
		5755
	],
	"./symbols/rai.svg": [
		"./src/assets/images/symbols/rai.svg",
		92523
	],
	"./symbols/report.svg": [
		"./src/assets/images/symbols/report.svg",
		73467
	],
	"./symbols/rikollinen_toiminta.svg": [
		"./src/assets/images/symbols/rikollinen_toiminta.svg",
		50330
	],
	"./symbols/sairaalasta_kotiutumisen_tuki.svg": [
		"./src/assets/images/symbols/sairaalasta_kotiutumisen_tuki.svg",
		25893
	],
	"./symbols/secretion.svg": [
		"./src/assets/images/symbols/secretion.svg",
		30865
	],
	"./symbols/selviytyminen.svg": [
		"./src/assets/images/symbols/selviytyminen.svg",
		49561
	],
	"./symbols/shame.svg": [
		"./src/assets/images/symbols/shame.svg",
		33859
	],
	"./symbols/sleep.svg": [
		"./src/assets/images/symbols/sleep.svg",
		6462
	],
	"./symbols/social_skills.svg": [
		"./src/assets/images/symbols/social_skills.svg",
		55853
	],
	"./symbols/star_grey.svg": [
		"./src/assets/images/symbols/star_grey.svg",
		52189
	],
	"./symbols/star_yellow.svg": [
		"./src/assets/images/symbols/star_yellow.svg",
		88020
	],
	"./symbols/sun.svg": [
		"./src/assets/images/symbols/sun.svg",
		13733
	],
	"./symbols/sun_grey.svg": [
		"./src/assets/images/symbols/sun_grey.svg",
		62641
	],
	"./symbols/suu_ja_hampaisto.svg": [
		"./src/assets/images/symbols/suu_ja_hampaisto.svg",
		96619
	],
	"./symbols/suun-kuivuminen.svg": [
		"./src/assets/images/symbols/suun-kuivuminen.svg",
		6142
	],
	"./symbols/sydan_ja_hengitys.svg": [
		"./src/assets/images/symbols/sydan_ja_hengitys.svg",
		34066
	],
	"./symbols/symbol_info.svg": [
		"./src/assets/images/symbols/symbol_info.svg",
		42308
	],
	"./symbols/symbol_open_symbol_menu.svg": [
		"./src/assets/images/symbols/symbol_open_symbol_menu.svg",
		23183
	],
	"./symbols/tarkastustoimenpiteet.svg": [
		"./src/assets/images/symbols/tarkastustoimenpiteet.svg",
		22208
	],
	"./symbols/tasks.svg": [
		"./src/assets/images/symbols/tasks.svg",
		57453
	],
	"./symbols/terveyden_edistaminen.svg": [
		"./src/assets/images/symbols/terveyden_edistaminen.svg",
		50969
	],
	"./symbols/terveyskayttaytyminen.svg": [
		"./src/assets/images/symbols/terveyskayttaytyminen.svg",
		40346
	],
	"./symbols/tissue_integrity.svg": [
		"./src/assets/images/symbols/tissue_integrity.svg",
		41528
	],
	"./symbols/toilet.svg": [
		"./src/assets/images/symbols/toilet.svg",
		49162
	],
	"./symbols/traumaattiset_kokemukset.svg": [
		"./src/assets/images/symbols/traumaattiset_kokemukset.svg",
		88387
	],
	"./symbols/turvallisuus.svg": [
		"./src/assets/images/symbols/turvallisuus.svg",
		2222
	],
	"./symbols/unen_hairiintyminen.svg": [
		"./src/assets/images/symbols/unen_hairiintyminen.svg",
		40562
	],
	"./symbols/vanhuksen_kaltoinkohtelu.svg": [
		"./src/assets/images/symbols/vanhuksen_kaltoinkohtelu.svg",
		81713
	],
	"./symbols/virallisten_palveluiden_supistaminen.svg": [
		"./src/assets/images/symbols/virallisten_palveluiden_supistaminen.svg",
		3521
	],
	"./symbols/virtsanpidatyskyvyttomyys.svg": [
		"./src/assets/images/symbols/virtsanpidatyskyvyttomyys.svg",
		37862
	],
	"./symbols/wallet.svg": [
		"./src/assets/images/symbols/wallet.svg",
		30758
	],
	"./symbols/ympariston_arviointi.svg": [
		"./src/assets/images/symbols/ympariston_arviointi.svg",
		72839
	],
	"./tasks/Spinner.gif": [
		"./src/assets/images/tasks/Spinner.gif",
		3100
	],
	"./tasks/absent.svg": [
		"./src/assets/images/tasks/absent.svg",
		77817
	],
	"./tasks/asiakkaan-kuva_harmaa.svg": [
		"./src/assets/images/tasks/asiakkaan-kuva_harmaa.svg",
		64211
	],
	"./tasks/call.svg": [
		"./src/assets/images/tasks/call.svg",
		31498
	],
	"./tasks/clock.svg": [
		"./src/assets/images/tasks/clock.svg",
		77892
	],
	"./tasks/communication.jpg": [
		"./src/assets/images/tasks/communication.jpg",
		50316
	],
	"./tasks/edit-hover.svg": [
		"./src/assets/images/tasks/edit-hover.svg",
		81827
	],
	"./tasks/edit.svg": [
		"./src/assets/images/tasks/edit.svg",
		17826
	],
	"./tasks/icon_calendar--hover.svg": [
		"./src/assets/images/tasks/icon_calendar--hover.svg",
		99530
	],
	"./tasks/icon_calendar.svg": [
		"./src/assets/images/tasks/icon_calendar.svg",
		378
	],
	"./tasks/icon_close.svg": [
		"./src/assets/images/tasks/icon_close.svg",
		6460
	],
	"./tasks/icon_customers--hover.svg": [
		"./src/assets/images/tasks/icon_customers--hover.svg",
		40065
	],
	"./tasks/icon_customers.svg": [
		"./src/assets/images/tasks/icon_customers.svg",
		80451
	],
	"./tasks/icon_logout--hover.svg": [
		"./src/assets/images/tasks/icon_logout--hover.svg",
		58778
	],
	"./tasks/icon_logout.svg": [
		"./src/assets/images/tasks/icon_logout.svg",
		36010
	],
	"./tasks/icon_menu-white.svg": [
		"./src/assets/images/tasks/icon_menu-white.svg",
		66657
	],
	"./tasks/icon_menu.svg": [
		"./src/assets/images/tasks/icon_menu.svg",
		9629
	],
	"./tasks/icon_messages--hover.svg": [
		"./src/assets/images/tasks/icon_messages--hover.svg",
		87412
	],
	"./tasks/icon_messages.svg": [
		"./src/assets/images/tasks/icon_messages.svg",
		91908
	],
	"./tasks/icon_mytasks--hover.svg": [
		"./src/assets/images/tasks/icon_mytasks--hover.svg",
		40244
	],
	"./tasks/icon_mytasks.svg": [
		"./src/assets/images/tasks/icon_mytasks.svg",
		4996
	],
	"./tasks/icon_play.svg": [
		"./src/assets/images/tasks/icon_play.svg",
		30310
	],
	"./tasks/icon_settings--hover.svg": [
		"./src/assets/images/tasks/icon_settings--hover.svg",
		94669
	],
	"./tasks/icon_settings.svg": [
		"./src/assets/images/tasks/icon_settings.svg",
		82447
	],
	"./tasks/icon_stop.svg": [
		"./src/assets/images/tasks/icon_stop.svg",
		39056
	],
	"./tasks/icon_submenu_1.svg": [
		"./src/assets/images/tasks/icon_submenu_1.svg",
		69327
	],
	"./tasks/icon_submenu_2.svg": [
		"./src/assets/images/tasks/icon_submenu_2.svg",
		90300
	],
	"./tasks/icon_tasks--hover.svg": [
		"./src/assets/images/tasks/icon_tasks--hover.svg",
		2182
	],
	"./tasks/icon_tasks.svg": [
		"./src/assets/images/tasks/icon_tasks.svg",
		10390
	],
	"./tasks/icon_user--hover.svg": [
		"./src/assets/images/tasks/icon_user--hover.svg",
		6047
	],
	"./tasks/icon_user.svg": [
		"./src/assets/images/tasks/icon_user.svg",
		62889
	],
	"./tasks/icon_wallet--hover.svg": [
		"./src/assets/images/tasks/icon_wallet--hover.svg",
		96133
	],
	"./tasks/icon_wallet.svg": [
		"./src/assets/images/tasks/icon_wallet.svg",
		88279
	],
	"./tasks/keys.svg": [
		"./src/assets/images/tasks/keys.svg",
		85938
	],
	"./tasks/nuoli-oikea_harmaa.svg": [
		"./src/assets/images/tasks/nuoli-oikea_harmaa.svg",
		93554
	],
	"./tasks/pause-bttn.jpg": [
		"./src/assets/images/tasks/pause-bttn.jpg",
		84193
	],
	"./tasks/present.svg": [
		"./src/assets/images/tasks/present.svg",
		35519
	],
	"./tasks/stop-bttn.jpg": [
		"./src/assets/images/tasks/stop-bttn.jpg",
		12161
	],
	"./tasks/symbol_info.svg": [
		"./src/assets/images/tasks/symbol_info.svg",
		52521
	],
	"./tasks/tp_assignation_log.svg": [
		"./src/assets/images/tasks/tp_assignation_log.svg",
		59290
	],
	"./tasks/tp_cash_register.svg": [
		"./src/assets/images/tasks/tp_cash_register.svg",
		31216
	],
	"./tasks/tp_customer_files.svg": [
		"./src/assets/images/tasks/tp_customer_files.svg",
		46357
	],
	"./tasks/tp_daily_reports.svg": [
		"./src/assets/images/tasks/tp_daily_reports.svg",
		26096
	],
	"./tasks/tp_diagnoses.svg": [
		"./src/assets/images/tasks/tp_diagnoses.svg",
		78536
	],
	"./tasks/tp_documents.svg": [
		"./src/assets/images/tasks/tp_documents.svg",
		23933
	],
	"./tasks/tp_events.svg": [
		"./src/assets/images/tasks/tp_events.svg",
		23570
	],
	"./tasks/tp_images.svg": [
		"./src/assets/images/tasks/tp_images.svg",
		7323
	],
	"./tasks/tp_key_log.svg": [
		"./src/assets/images/tasks/tp_key_log.svg",
		62797
	],
	"./tasks/tp_medication.svg": [
		"./src/assets/images/tasks/tp_medication.svg",
		50980
	],
	"./tasks/tp_tasks.svg": [
		"./src/assets/images/tasks/tp_tasks.svg",
		55729
	],
	"./tasks/tp_wallet.svg": [
		"./src/assets/images/tasks/tp_wallet.svg",
		97986
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./src/assets/images lazy recursive ^\\.\\/.*$";
module.exports = webpackAsyncContext;